export default function generateS3Key({
  appId,
  buildId,
  filenameSuffix,
}: {
  appId: string;
  buildId: string;
  filenameSuffix: string;
}): string {
  return `${appId}/sourceArchives/${buildId}--${filenameSuffix}`;
}
